import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const OneDotNineTeenDotOne = () => {
  return (
    <ChangelogInstance version="1.19.1" date="2019-10-06" >
      <li>Fixes bug that broke csgolounge and csgotraders bumping</li>
      <li>Inventory and trade offer searching performance improvements</li>
    </ChangelogInstance>
  );
}

export default OneDotNineTeenDotOne;